import React from 'react';

import services from 'services';
import { convertExceptionToJson, logger } from 'utils';

class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean }> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    logger.error(error);
    services.appFrame.error.main.addError({
      title: 'errors.runtime_error.title',
      message: '',
      details: {
        type: 'RUNTIME_ERROR',
        timestamp: new Date(),
        error: convertExceptionToJson(error),
      },
    });
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
